'use client'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { urlWithParams } from '@marketplace-web/shared/url-util'
import {
  ItemBreadcrumbDto,
  ItemPageBreadcrumbsPluginModel,
  clickEvent,
} from '@marketplace-web/item-page/item-page-data'

import BreadcrumbsComponent from './Breadcrumbs'
import { ROOT_URL } from '../../constants/routes'

const getUrlWithParams = (url: string) => {
  if (url === ROOT_URL) return url

  return urlWithParams(url, { referrer: 'item-crumbs' })
}

const ItemPageBreadcrumbsPlugin = (breadcrumbsData: ItemPageBreadcrumbsPluginModel) => {
  const { track } = useTracking()

  const trackBreadcrumbClick = (breadcrumb: ItemBreadcrumbDto, position: number) => () => {
    track(
      clickEvent({
        screen: 'item',
        target: 'breadcrumb',
        targetDetails: JSON.stringify({
          position: position + 1,
          breadcrumb_title: breadcrumb.title,
        }),
      }),
    )
  }

  return (
    <div className="u-ui-margin-top-medium">
      <BreadcrumbsComponent truncate>
        {breadcrumbsData.breadcrumbs.map((breadcrumb, index) => (
          <BreadcrumbsComponent.Item
            key={breadcrumb.url}
            url={getUrlWithParams(breadcrumb.url)}
            title={breadcrumb.title}
            onClick={trackBreadcrumbClick(breadcrumb, index)}
          />
        ))}
      </BreadcrumbsComponent>
    </div>
  )
}

export default ItemPageBreadcrumbsPlugin
